const { makeStyles } = require("@material-ui/core");

export const useStyles = makeStyles((theme) => ({
  locationWrapper: {
    backgroundColor: "#fff",
    borderRadius: 5,
    minWidth: 360,
  },
  infoText: {
    ...theme.typography.body2,
    fontStyle: "italic",
  },
}));
